/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li2_TermInputs */

const tr_iade_iptal_s5_li2_term = /** @type {(inputs: Iade_Iptal_S5_Li2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İade yöntemi ve süresi:`)
};

const en_iade_iptal_s5_li2_term = /** @type {(inputs: Iade_Iptal_S5_Li2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund method and period:`)
};

const de_iade_iptal_s5_li2_term = /** @type {(inputs: Iade_Iptal_S5_Li2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstattungsweg und Frist:`)
};

const ru_iade_iptal_s5_li2_term = /** @type {(inputs: Iade_Iptal_S5_Li2_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Способ и срок возврата:`)
};

/**
* | output |
* | --- |
* | "Refund method and period:" |
*
* @param {Iade_Iptal_S5_Li2_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li2_term = /** @type {((inputs?: Iade_Iptal_S5_Li2_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li2_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li2_term(inputs)
	if (locale === "de") return de_iade_iptal_s5_li2_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li2_term(inputs)
	return tr_iade_iptal_s5_li2_term(inputs)
});